import { registerQuery } from 'data-fetching-client';
import { fetchInboxActiveMigrationStatus, fetchMigrationStatus, fetchAllMigrationRecords, fetchMigrationResults, fetchChannelsActiveMigrationStatus } from '../clients/help-desk-migration.api';
export const fetchMigrationStatusQuery = registerQuery({
  args: ['channelInstanceId'],
  fetcher: fetchMigrationStatus,
  fieldName: 'helpdeskMigrationStatus'
});
export const fetchMigrationToAnInboxStatusQuery = registerQuery({
  args: ['channelInstanceId'],
  fetcher: fetchMigrationStatus,
  fieldName: 'helpDeskToInboxMigrationStatus'
});
export const fetchInboxActiveMigrationStatusQuery = registerQuery({
  args: ['inboxId'],
  fetcher: fetchInboxActiveMigrationStatus,
  fieldName: 'helpdeskInboxActiveMigrationStatus'
});
export const fetchAllMigrationRecordsQuery = registerQuery({
  fetcher: fetchAllMigrationRecords,
  fieldName: 'helpdeskAllMigrationRecords'
});
export const fetchMigrationResultsQuery = registerQuery({
  args: ['channelInstanceId'],
  fetcher: fetchMigrationResults,
  fieldName: 'helpdeskMigrationResults'
});
export const fetchChannelsActiveMigrationStatusQuery = registerQuery({
  args: ['channelInstanceIds'],
  fetcher: fetchChannelsActiveMigrationStatus,
  fieldName: 'helpdeskChannelsMigrationStatus'
});